import {
  Box,
  Link as MuiLink,
  Stack,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from '@mui/material'
import { Link, useLocation } from 'react-router-dom'

import logoWhiteSrc from '~/assets/images/corp/logo-white.webp'
import libbySrc from '~/assets/images/libby/libby-happy-right-side.webp'
import useIsPartner from '~/features/partners/hooks/useIsPartner'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { ESiteImagesTypes } from '~/features/partners/models'
import { EClientPath, EMarketingClientPath } from '~/models/api'
import rem, { getWhiteOrBlackTextColorByBackground } from '~/utils/ui'

type TProps = {
  sx?: SxProps<Theme>
}

function Logo({ sx = {} }: TProps) {
  const location = useLocation()
  const theme = useTheme()
  const isPartner = useIsPartner()
  const { partner } = usePartnerCentralized()
  const isPartnerAdmin = location.pathname.includes(EClientPath.partnerAdmin)

  return (
    <MuiLink
      component={Link}
      to={isPartner ? '#' : EMarketingClientPath.home}
      sx={{
        textDecoration: 'none',
        mr: 2,
        cursor: isPartner ? 'initial' : 'pointer',
        ...sx,
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          gap: 2,
        }}
      >
        {isPartner ? (
          <Box
            sx={{
              alignSelf: 'center',
              flex: '1 0 auto',
              marginLeft: rem(41),
              height: rem(32),
              width: { xxxs: rem(108), sm: rem(129) },
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              backgroundImage: `url(${
                partner?.siteImages?.find(
                  (i) => i.type === ESiteImagesTypes.portalNavigationLogo,
                )?.imageUrl
              })`,
            }}
          />
        ) : (
          <>
            <Box
              sx={{
                height: rem(32),
                width: rem(32),
                marginBlock: 'auto',
                backgroundImage: `url(${libbySrc})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
              }}
            />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'center',
                justifyContent: 'center',
                gap: 0,
              }}
            >
              <Box
                sx={{
                  height: rem(20),
                  width: { xxxs: rem(108), sm: rem(129) },
                  backgroundImage: `url(${logoWhiteSrc})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'contain',
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  color: getWhiteOrBlackTextColorByBackground(
                    theme.palette.menuBackground,
                    theme,
                  ),
                  fontWeight: 'semibold',
                  letterSpacing: rem(2.1),
                  fontSize: rem(11),
                  lineHeight: rem(11),
                }}
              >
                {isPartnerAdmin ? 'PARTNER ADMIN PORTAL' : 'PORTAL'}
              </Typography>
            </Box>
          </>
        )}
      </Stack>
    </MuiLink>
  )
}

export default Logo
